<template>
  <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <FaceCamera ref="cameratree" :OnTreeSelected="OnTreeSelected"></FaceCamera>
      </div>
      <div class="zj-layout-right">
        <FaceList ref="facelist"></FaceList>
      </div>
  </zj-layout-container>
</template>
<script>

import FaceList from "./FaceList";
import FaceCamera from "./FaceCamera";

export default {
  name: "FaceManager",
  controller: "UI",
  action: "FaceManager",
  components: {
    FaceList,
    FaceCamera
  },
  data(){
    return{

    }
  },
  created:function(){
    
  },
  mounted: function() {
    
  },
  methods:{
    OnTreeSelected(data){
    // console.log(data.IndexCode);
     this.$refs.facelist.refreshImage(data);
    }
  },
}

</script>